/**
 * Test IDs for QA automation.
 */
export const testIds = {
  extensionInstallPromptCancel: "extension-install-prompt-cancel",
} as const;
